import React from 'react'
import Navbar from "./invitationpage/Navbar";
import Content from "./invitationpage/Content";
import Footer from "./landingpage/Footer";
import {Box} from "@mui/material";

const InvitationPage = () => {
    return (
        <Box
            sx={{
                display: 'flex',
                flexDirection: 'column',
                minHeight: '100vh',
            }}
        >
            <Navbar />
            <Content />
            <Footer />
        </Box>
    )
}

export default InvitationPage